// @flow
import React from 'react';

import Button from './Button';

const AnchorButton = Button.withComponent('a');

type linkButtonProps = {
  disabled: boolean,
  onClick?: MouseEvent => void,
};

const LinkButton = ({ disabled, onClick, ...props }: linkButtonProps) => (
  <AnchorButton
    {...props}
    disabled={disabled}
    onClick={clickEvent => {
      // Because <a> tags can't be "disabled", this simulates the behaviour by preventing the
      // default click behaviour - opening the link - when the link is clicked.
      // NOTE: The link will still receive focus and trigger a focus event when it's clicked while
      // it's disabled.
      if (disabled) {
        clickEvent.preventDefault();
        // The click handler shouldn't be called if the button is disabled
        return;
      }
      if (typeof onClick === 'function') {
        onClick(clickEvent);
      }
    }}
  />
);

LinkButton.defaultProps = {
  disabled: false,
  onClick: undefined,
};

export default LinkButton;
